export default __webpack_public_path__ + "static/media/BBGif.ed395782.gif";